export default {"src":"/login-app/[GIT_HASH]/_next/static/media/cost_franc.e827eb2b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};